import React from 'react'
import './LearningData.scss';
import DataImage from '../../../Assets/Images/new.png';
export default function LearningData() {
    return (
        <div>
            <div className="leaning-data-alignment" id="Business">
                <div className="new-container">
                    <div className="learning-grid">
                        <div className="learning-grid-items">
                            <div className="learning-image">
                                <img src={DataImage} alt="dataimg"/>
                            </div>
                        </div>
                        <div className="learning-grid-items">
                            <p>Now is the time to transition towards industry-specific applications of AI, Deep Learning and Data Science. </p>
                            <h3>Using AI for business is a relatively new concept. </h3>
                            <span>
                                AI can automate processes that are manual, labor-intensive, or simply time-consuming. It can help you retain talent by analyzing data in real time to identify unproductive workers, identify potential candidates who may be more effective under some conditions, or optimize your marketing campaigns to get the most out of your advertising dollars. In short, AI allows businesses 
                                to do work that previously would have been done by people — and does so with an efficiency and effectiveness that can't be replicated by human workers.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
